<div class="container">
  <div class="page-header">
    <a
      (click)="routeBack()"
      queryParamsHandling="merge"
      class="link typog-body-large-bold"
      ><i class="fa-solid fa-arrow-left mr-1"></i>Back</a
    >
    <div class="replacement--title">
      <h3>
        <span>{{ selected?.make }}</span>
        <span> {{ selected?.appliance_category }}</span>
      </h3>
      <h5 class="mt-1">{{ selected?.model }}</h5>
    </div>
  </div>

  <div class="summary-header">
    <div class="summary-header__notice" *ngIf="showProtectionNotice">
      <dgx-components-icon
        [name]="'info-circle'"
        [size]="'sm'"
        class="mr-2"
      ></dgx-components-icon>
      <p>Your new model will be protected as part of your existing plan.</p>
    </div>
    <app-selected-item
      [data]="selected"
      [costSummary]="costSummary"
    ></app-selected-item>
  </div>

  <div class="summary-content">
    <app-accordion [isReversed]="true" (toggled)="isOpenClick($event)">
      <ng-container header> {{ text }} purchase details</ng-container>
      <ng-container content>
        <app-upfront-payment-summary
          [data]="upfrontPaymentSummary"
          [selected]="selected"
        >
        </app-upfront-payment-summary>
      </ng-container>
    </app-accordion>
  </div>
</div>
